/**
 * DIEUKYDIEU.TV - AUDIO PLAYER DOM HELPERS & TITLE FORMATTERS
 */

import { t } from '../i18n.js';
import { state } from '../state.js';
import { audioPlaylist } from '../data/player-playlist.js';
import { currentAudioIndex } from './player-state.js';

export function getTrackTitle(track) {
    if (!track) return t('player_default_title');
    const lang = state.currentLang;
    if (track.title_i18n && track.title_i18n[lang]) return track.title_i18n[lang];
    return track.title;
}

export function getTrackArtist(track) {
    if (!track) return t('player_default_artist');
    const lang = state.currentLang;
    if (track.artist_i18n && track.artist_i18n[lang]) return track.artist_i18n[lang];
    return track.artist;
}

export function updateCurrentTrackDisplay() {
    if (currentAudioIndex >= 0 && currentAudioIndex < audioPlaylist.length) {
        const track = audioPlaylist[currentAudioIndex];
        const trackTitle = getTrackTitle(track);
        const trackArtist = getTrackArtist(track);
        const mpTitle = document.getElementById('mp-title');
        const mpArtist = document.getElementById('mp-artist');
        const fpTitle = document.getElementById('fp-title');
        const fpArtist = document.getElementById('fp-artist');
        const fpLyricsTitle = document.getElementById('fp-lyrics-title');
        const fpLyricsArtist = document.getElementById('fp-lyrics-artist');
        if (mpTitle) mpTitle.innerText = trackTitle;
        if (mpArtist) mpArtist.innerText = trackArtist;
        if (fpTitle) fpTitle.innerText = trackTitle;
        if (fpArtist) fpArtist.innerText = track.credits || trackArtist;
        if (fpLyricsTitle) fpLyricsTitle.innerText = trackTitle;
        if (fpLyricsArtist) fpLyricsArtist.innerText = track.credits || trackArtist;
    }
}

export function updatePlayState(playing) {
    const icon = playing ? 'pause' : 'play_arrow';
    const mpPlayBtn = document.getElementById('mp-play-btn');
    const fpPlayBtn = document.getElementById('fp-play-btn');
    const mpThumb = document.getElementById('mp-thumb');
    const fpArt = document.getElementById('fp-art');

    if (mpPlayBtn) mpPlayBtn.innerHTML = `<span class="material-symbols-rounded">${icon}</span>`;
    if (fpPlayBtn) fpPlayBtn.innerHTML = `<span class="material-symbols-rounded">${icon}</span>`;
    if (mpThumb) mpThumb.classList.toggle('playing', playing);
    if (fpArt) fpArt.classList.toggle('playing', playing);
}

export function updateSliderTrack(percent) {
    const slider = document.getElementById('fp-slider');
    if (slider) {
        const safePercent = Math.min(100, Math.max(0, percent));
        slider.style.background = `linear-gradient(to right, var(--accent-color) 0%, var(--accent-color) ${safePercent}%, var(--player-track-bg, var(--glass-border)) ${safePercent}%, var(--player-track-bg, var(--glass-border)) 100%)`;
    }
}
